import { useState, useEffect, useMemo } from "react";
import CustomDatePicker from "../../components/CustomDatePicker";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { saveCreateGameData, saveGameCreatePayload, savePaymentIntentId } from "../../redux/UserDataSlice";
import { IoIosArrowDown } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { FiChevronDown } from 'react-icons/fi';
import { FaDollarSign } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa6";
import { FaMapMarkedAlt } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton";
import CustomSelect from "../../components/CustomSelect";
import CustomInput from "../../components/CustomInput";
import { RxCross2 } from "react-icons/rx";
import GoogleMapComponent from "../../components/GoogleMap";
import PaginatedSelect from "../../components/PaginatedSelect";
import debounce from "lodash/debounce";

const CreateFormField = () => {

    const [selectedOption, setSelectedOption] = useState('courts');
    const [showDropdown, setShowDropdown] = useState(false);
    const location = useLocation();
    const { accessToken, saveCardDetailData, paymentIntentId, transactionId } = useSelector((state) => state.loginInfo);
    const gameData = location?.state?.gameData;
    const [formData, setFormData] = useState({
        courtName: "",
        gameName: "",
        level: "",
        personsType: "More",
        numberOfPersons: "",
        dateTime: "",
        description: "",
        sportName: "",
        duration: "",
        zipCode: '',
        city: ''
    });
    const [gameType, setGameType] = useState("open");
    const [priceType, setPriceType] = useState("paid");
    const [invitedPlayersList, setInvitedPlayersList] = useState(location.state?.invitedPlayers || []);
    const [price, setPrice] = useState(120);
    const [cityOptions, setCityOptions] = useState([]);
    const [citySearch, setCitySearch] = useState('');
    const [sports, setSports] = useState([]);
    const { createGameData } = useSelector((state) => state.loginInfo);
    const [checkboxValues, setCheckboxValues] = useState({
        exclusionList: false,
        autoAccept: false,
    });
    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState({});
    const [courtData, setCourtData] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState();
    const [showMap, setShowMap] = useState();

    // paginated and searchable court 
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const [selectedCourt, setSelectedCourt] = useState(null);


    useEffect(() => {
        setInvitedPlayersList(JSON.parse(localStorage.getItem("invitedPlayers") || "[]"));
    }, [])

    useEffect(() => {
        const formattedLevel = gameData?.level?.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
        const formatSingularity = (value) => {
            const map = {
                SINGLES: "Singles",
                DOUBLES: "Doubles",
                MULTIPLAYER: 'MULTIPLAYER'
            };

            return map[value?.toUpperCase()] || "";
        };

        if (gameData) {
            setFormData({
                courtName: gameData?.courtName || "",
                gameName: gameData?.gameName || "",
                level: formattedLevel || "",
                personsType: formatSingularity(gameData?.singularity),
                numberOfPersons: gameData?.requiredPlayers?.toString() || "",
                dateTime: parseToJSDate(gameData?.startTime),
                description: gameData?.gameDescription || "",
                sportName: gameData?.sportName || "",
                duration: calculateDuration(gameData?.startTime, gameData?.endTime),
                zipCode: "",
                city: gameData?.city || ""
            });
            setPriceType(gameData.paid == true ? 'paid' : 'noCharge');
            setGameType(gameData.invitations == null ? 'open' : 'invitation')
            gameData.paid == true && setPrice(gameData?.courtPrice);
            setCheckboxValues(
                {
                    exclusionList: gameData?.exclusionListEnabled,
                    autoAccept: gameData?.autoAcceptance == false ? false : true
                })
            const result = gameData?.invitations?.map(item => ({
                id: item.invitedUser,
                name: item.invitedUserName
            })) || [];
            setInvitedPlayersList(result)
        }
    }, []);

    const debouncedSearch = useMemo(() =>
        debounce((value) => {
            setSearch(value);
            setPage(0

            );
        }, 500),
        []);

    const handleLoadMore = () => {
        if (loader || !hasMore) return;
        setPage(prev => prev + 1);
    };


    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);



    const fetchCourt = async () => {
        try {
            setLoader(true);
            const result = await apiHandler({
                url: endpoint.FETCH_COURT,
                method: "GET",
                authToken: accessToken?.accessToken,
                params: {
                    ...search.trim() && { key: search.trim() },
                    ...formData.sportName && { sport: formData.sportName },
                    page,
                    size: 20
                }
            });
            console.log(`fetch court response🔴 ${search.trim()} page ${page} `, result.data);
            if (!result?.data?.error) {
                const courts = result?.data?.courts;
                if (page === 0) {
                    setCourtData(courts);
                } else {
                    setCourtData(prev => [...prev, ...courts]);  // append when scrolling
                }
                setHasMore(page < result.data.totalPages);
                setLoader(false)
            } else {
                setLoader(false)
                toast.error("Something went wrong");
            }
        } catch (error) {
            console.error("Error fetching games:", error);
        }
    };

    useEffect(() => {
        fetchCourt();
    }, [formData.sportName, page, search]);


    useEffect(() => {
        fetchGames();
    }, [])

    useEffect(() => {
        setPage(0);
        setSelectedCourt(null);
        setFormData(prev => ({ ...prev, courtName: "" }));
    }, [formData.sportName]);


    useEffect(() => {
        if (createGameData) {
            setFormData(createGameData);
        }
    }, [createGameData]);

    const fetchGames = async () => {
        try {
            const result = await apiHandler({
                url: endpoint.CHOOSE_SPORT,
                method: "GET",
                authToken: accessToken?.accessToken
            });
            setLoader(true);
            if (!result?.data?.error) {
                setSports(result?.data);
                setLoader(false);
            } else {
                toast.error("Something went wrong");
                setLoader(false);
            }
        } catch (error) {
            console.error("Error fetching games:", error);
        }
    };



    const calculateDuration = (startTime, endTime) => {
        if (!startTime || !endTime) return "";

        const [startDate, startClock] = startTime.split(" ");
        const [endDate, endClock] = endTime.split(" ");

        const start = new Date(startDate.split("-").reverse().join("-") + "T" + startClock);
        const end = new Date(endDate.split("-").reverse().join("-") + "T" + endClock);

        if (isNaN(start.getTime()) || isNaN(end.getTime())) return "";

        const durationInMinutes = (end - start) / (1000 * 60);
        const durationInHours = durationInMinutes / 60;

        return durationInHours.toFixed(1); // returns "3.0"
    };

    const parseToJSDate = (dateTimeStr) => {
        if (!dateTimeStr) return null;

        const [datePart, timePart] = dateTimeStr.split(" ");
        const [day, month, year] = datePart.split("-");

        // Convert to ISO format
        const isoString = `${year}-${month}-${day}T${timePart}`;
        const dateObj = new Date(isoString);

        return isNaN(dateObj.getTime()) ? null : dateObj;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'numberOfPersons') {
            if (value?.length > 1 && value.startsWith('0')) return;

            const number = parseInt(value, 10);
            if (number > 100) return;
            if (number < 1) return;
        }

        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === 'zipCode' && value?.length === 5) {
            fetchCityFromZip(value);
        }
    };

    const filteredCities = cityOptions
        .filter(city => city.toLowerCase().includes(citySearch.toLowerCase()))
        .join(', ');

    const handleDateChange = (date) => {
        if (date instanceof Date && !isNaN(date)) {
            setFormData((prev) => ({ ...prev, dateTime: date }));

            if (errors.dateTime) {
                setErrors({
                    ...errors,
                    dateTime: ""
                });
            }
        } else {
            console.error("Invalid date selected:", date);
        }
    };

    const handleRadioChange = (e) => {
        setFormData({ ...formData, personsType: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error("Please fill in all required fields");
            return;
        }
        const selectedSport = sports?.sports?.find(sport => sport?.sportName === formData?.sportName);
        const sportId = selectedSport ? selectedSport?.id : null;
        const courtId = selectedCourt?.value || null;
        const invitedPlayersId = invitedPlayersList?.map(item => item.id);
        const isEligibleForService = saveCardDetailData?.userConfgis?.isEligibleForService;

        const startDate = formData?.dateTime;
        const duration = formData?.duration;
        const endDate = calculateEndTime(startDate, Number(duration));
        const payload = {
            sportId: sportId,
            courtId: courtId,
            city: formData.city,
            gameName: formData.gameName,
            startTime: formatStartDate(formData?.dateTime),
            endTime: endDate,
            singularity: formData.personsType.toUpperCase(),
            gameDescription: formData.description,
            isPaid: priceType === "paid",
            courtPrice: priceType === "paid" ? Number(price) : 0,
            autoAcceptance: checkboxValues?.autoAccept,
            requiredPlayers: Number(formData.numberOfPersons),
            level: formData.level.replace(/\s+/g, '_').toUpperCase(),
            invitees: invitedPlayersId,
            isIOG: gameType == 'open' ? false : true,
            paymentIntentId: paymentIntentId,
            transactionId: transactionId,
            exclusionListEnabled: checkboxValues?.exclusionList,
        };
        dispatch(saveGameCreatePayload(payload));
        if (isEligibleForService || paymentIntentId) {
            try {
                const result = await apiHandler({
                    url: gameData?.gameId ? `${endpoint.CREATE_GAMES}?id=${gameData.gameId}` : `${endpoint.CREATE_GAMES}`,
                    method: "POST",
                    data: payload,
                    authToken: accessToken.accessToken
                });
                const response = result.data;
                if (response && !response?.user_description) {
                    toast.success("Game created successfully!");
                    dispatch(savePaymentIntentId(''));
                    navigate('/your-games');
                    localStorage.removeItem("invitedPlayers");
                } else {
                    dispatch(savePaymentIntentId(''));
                    toast.error(response?.user_description || "Failed to create game");
                }
            } catch (error) {
                console.error("Error:", error);
                toast.error("An error occurred while creating the game");
            }
        }
        else {
            setIsOpen(!isOpen);
        }

    };

    const onInviteFriend = async () => {
        navigate('/invite-player');
        dispatch(saveCreateGameData(formData));
    }

    function calculateEndTime(startDate, durationInHours) {
        const start = new Date(startDate);
        const duration = parseInt(durationInHours, 10);

        if (isNaN(duration)) {
            throw new Error("Invalid duration");
        }

        const end = new Date(start.getTime() + duration * 60 * 60 * 1000);
        const day = String(end.getDate()).padStart(2, "0");
        const month = String(end.getMonth() + 1).padStart(2, "0");
        const year = end.getFullYear();
        const hours = String(end.getHours()).padStart(2, "0");
        const minutes = String(end.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }

    function formatStartDate(inputDate) {
        const date = new Date(inputDate);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }

    const handleCourtSelectFromMap = (court) => {
        setFormData((prev) => ({
            ...prev,
            courtName: court.courtName
        }));

        if (errors.courtName) {
            setErrors({
                ...errors,
                courtName: ""
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Check required fields
        if (!formData.sportName) newErrors.sportName = "Sport is required";
        if (!formData.courtName && !formData.city) {
            newErrors.courtName = "Either Court or City is required";
            newErrors.city = "Either Court or City is required";
        }

        if (!formData.gameName) newErrors.gameName = "Game name is required";
        if (!formData.level) newErrors.level = "Skill level is required";
        // if (formData.level && !formData.numberOfPersons) newErrors.numberOfPersons = "Number of persons is required";
        if (!formData.dateTime) newErrors.dateTime = "Date and time is required";
        if (!formData.duration) newErrors.duration = "Duration is required";
        if (!formData.description) newErrors.description = "Description is required";

        // Validate number fields
        if (formData.numberOfPersons && isNaN(Number(formData.numberOfPersons))) {
            newErrors.numberOfPersons = "Must be a valid number";
        }

        if (formData.duration && isNaN(Number(formData.duration))) {
            newErrors.duration = "Must be a valid number";
        }

        setErrors(newErrors);

        // Return true if no errors (form is valid)
        return Object.keys(newErrors)?.length === 0;
    };

    const formatDate = (date) => {
        if (!date) return "";
        return format(date, "MMM dd yyyy | hh:mm a");
    };

    const fetchCityFromZip = async (zip) => {
        try {
            const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
            if (!res.ok) throw new Error('Invalid ZIP');
            const data = await res.json();
            const place = data.places[0]?.['place name'];
            setFormData(prev => ({ ...prev, city: place }));
            setCityOptions([place]); // You can add more if needed
        } catch (e) {
            console.error(e);
            setFormData(prev => ({ ...prev, city: '' }));
            setCityOptions([]);
        }
    };

    const handleCheckboxChange = (e) => {
        const { id, checked } = e.target;
        setCheckboxValues((prev) => ({
            ...prev,
            [id]: checked,
        }));
    };

    const handleRemoveFriend = (id) => {
        setInvitedPlayersList((prev) => {
            const updatedList = prev.filter((friend) => friend.id !== id);
            localStorage.setItem("invitedPlayers", JSON.stringify(updatedList));
            return updatedList;
        });
    };

    const toggleMap = () => {
        setShowMap(prev => !prev);
    };

    const durationOptions = Array.from({ length: 22 }, (_, i) => (0.5 * (i + 1)).toFixed(1));

    return (
        <>
            <div className="row create-game-form-wrapper">
                <div className="col-lg-3 mb-4 ">
                    <CustomSelect
                        label="Sports"
                        name="sportName"
                        value={formData?.sportName}
                        onChange={handleInputChange}
                        options={sports?.sports}
                        optionLabelKey="sportName"
                        optionValueKey="sportName"
                        error={errors?.sportName}
                        placeholder="Choose sports"
                        required
                    />

                </div>
                <div className="col-lg-4 mb-4">
                    <div className="row">
                        <div className="col-lg-12 mb-1">
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="searchOption"
                                    id="courts"
                                    value="courts"
                                    style={{ cursor: 'pointer' }}
                                    checked={selectedOption === 'courts'}
                                    onChange={() => setSelectedOption('courts')}
                                />
                                <label className="form-check-label" htmlFor="courts" >Courts</label>
                            </div>

                            <div className="form-check form-check-inline">
                                <input className="form-check-input " style={{ cursor: 'pointer' }} type="radio" name="searchOption" id="aroundCity"
                                    value="aroundCity"
                                    checked={selectedOption === 'aroundCity'}
                                    onChange={() => setSelectedOption('aroundCity')}
                                />
                                <label className="form-check-label" htmlFor="aroundCity">Around City</label>
                            </div>
                        </div>

                        {/* Courts Dropdown */}
                        {selectedOption === 'courts' && (
                            <PaginatedSelect
                                name="courtId"
                                value={selectedCourt}
                                onChange={(id, label) => {
                                    setSelectedCourt({ value: id, label });
                                    setSearch('');
                                    setPage(0);
                                    setFormData(prev => ({
                                        ...prev,
                                        courtName: label
                                    }));
                                }}
                                onLoadMore={handleLoadMore}
                                hasMore={hasMore}
                                loading={loader}
                                onSearch={debouncedSearch}
                                options={courtData}
                                error={errors?.courtId}
                                required
                            />
                        )}

                        {/* Zip Code Input */}
                        {selectedOption === 'aroundCity' && (
                            <>
                                <div>
                                    <CustomInput
                                        label="Zip Code"
                                        name="zipCode"
                                        value={formData.zipCode}
                                        onChange={handleInputChange}
                                        placeholder="Enter Zip Code"
                                        type="text"
                                        maxLength={5}
                                        star="*"
                                        className={errors.zipCode ? "is-invalid" : ""}
                                        style={{ height: "48px", borderRadius: "13px", cursor: "pointer" }}
                                    />
                                    {errors.zipCode && <div className="invalid-feedback">{errors.zipCode}</div>}

                                </div>

                                <div style={{ marginTop: '10px', position: 'relative' }}>
                                    <div style={{ position: 'relative' }}>
                                        <CustomInput
                                            label="City"
                                            name="city"
                                            value={formData.city || ""}
                                            placeholder="Choose city"
                                            type="text"
                                            readOnly
                                            onClick={() => setShowDropdown((prev) => !prev)}
                                            style={{
                                                height: "48px",
                                                borderRadius: "13px",
                                                backgroundColor: "#f8f9fa",
                                                paddingRight: "40px",
                                                cursor: "pointer",
                                                color: formData.city ? "#000" : "#999",
                                            }}
                                        />

                                        {/* Dropdown Arrow */}
                                        <span
                                            onClick={() => setShowDropdown((prev) => !prev)}
                                            style={{
                                                position: 'absolute',
                                                right: '12px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                color: '#555',
                                            }}
                                        >
                                            <IoIosArrowDown />
                                        </span>
                                    </div>

                                    {/* Dropdown Content */}
                                    {showDropdown && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                zIndex: 1000,
                                                background: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '10px',
                                                width: '100%',
                                                marginTop: '5px',
                                                padding: '10px',
                                            }}
                                        >
                                            <input
                                                type="text"
                                                value={citySearch}
                                                onChange={(e) => setCitySearch(e.target.value)}
                                                placeholder="Search city"
                                                className="form-control mb-2"
                                            />

                                            {
                                                filteredCities?.length > 0 ? (
                                                    [filteredCities]?.map((city, idx) => (
                                                        <div
                                                            key={idx}
                                                            onClick={() => {
                                                                setFormData((prev) => ({ ...prev, city }));
                                                                setShowDropdown(false);
                                                                setCitySearch('');
                                                            }}
                                                            style={{
                                                                padding: '5px 10px',
                                                                cursor: 'pointer',
                                                                borderBottom: idx !== filteredCities?.length - 1 ? '1px solid #eee' : 'none',
                                                            }}
                                                        >
                                                            {city}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div style={{ padding: '5px 10px', color: '#aaa' }}>No city found</div>
                                                )}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className="col-lg-5 mb-4 d-flex justify-content-between">
                    {courtData?.length > 0 &&
                        <div className=" me-2">
                            <CustomButton buttonText={showMap ? 'Hide Map' : 'Choose from Map'} className="create-game-btn" onClick={toggleMap}
                                style={{ width: '175px' }}
                                icon={<FaMapMarkedAlt style={{
                                    color: 'white',
                                    padding: '5px',
                                    borderRadius: '15px',
                                    cursor: 'pointer',
                                    width: '25px',
                                    height: '25px',
                                    marginRight: '10px'
                                }}
                                />} />
                        </div>
                    }
                    <div>
                        <label htmlFor="gameName" className="form-label">
                            Game Name <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            id="gameName"
                            name="gameName"
                            placeholder="game name"
                            className={`form-control form-control-border ${errors.gameName ? 'is-invalid' : ''}`}
                            value={formData.gameName}
                            onChange={handleInputChange}
                        />
                        {errors.gameName && <div className="invalid-feedback">{errors.gameName}</div>}
                    </div>
                </div>
            </div>

            <div className="row row-gap-3 row-gap-sm-5" >
                <div className="col-lg-3 " >
                    <label htmlFor="level" className="form-label">
                        Skill Level <span className="text-danger">*</span>
                    </label>
                    <select style={{ height: '48px', borderRadius: '13px', cursor: 'pointer' }} id="level" name="level" className={`form-select form-control-border ${errors.level ? 'is-invalid' : ''}`} value={formData.level} onChange={handleInputChange}    >
                        <option value="">Choose level</option>
                        <option value="Practice">Practice</option>
                        <option value="Beginner">Beginner</option>
                        <option value="Intermediate">Intermediate</option>
                        <option value="Upper Intermediate">Upper Intermediate</option>
                        <option value="Proficient">Proficient</option>
                        <option value="League Player">League Player</option>
                        <option value="Young Pro Player">Young Pro Player</option>
                        <option value="College Playerr">College Player</option>
                        <option value="Pro">Pro</option>
                    </select>
                    {errors.level && <div className="invalid-feedback">{errors.level}</div>}
                </div>
                {/* Invite Friends */}
                <div className="col-lg-2">
                    <label className="form-label">Invite Friends</label>
                    <div className="d-flex justify-content-start">
                        <CustomButton buttonText={'Invite Friends'} className="create-game-btn" onClick={onInviteFriend}
                            icon={<FaUserPlus style={{
                                color: 'white',
                                padding: '5px',
                                borderRadius: '15px',
                                cursor: 'pointer',
                                width: '25px',
                                height: '25px',
                                marginRight: '10px'
                            }}
                            />} />
                    </div>

                    <div className="mt-2 d-flex flex-wrap gap-1">
                        {invitedPlayersList?.length > 0 && invitedPlayersList?.filter((item) => item.name)
                            .slice(0, 10)
                            .map((item, index) => (
                                <span
                                    key={index}
                                    className="badge  text-white d-flex align-items-center"
                                    style={{
                                        padding: "6px 10px",
                                        borderRadius: "20px",
                                        gap: "6px",
                                        background: 'green'
                                    }}
                                >
                                    {item.name}
                                    <IoClose
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleRemoveFriend(item.id)}
                                    />
                                </span>
                            ))}
                    </div>
                </div>

                <div className=" col-lg-4 ">
                    <label className="form-label ">Game Format</label>
                    <div className="d-flex">
                        <div className="form-check me-3">
                            <input
                                type="radio"
                                id="singles"
                                name="personsType"
                                className="form-check-input form-control-border"
                                value="Singles"
                                style={{ cursor: 'pointer' }}
                                checked={formData.personsType === "Singles"}
                                onChange={handleRadioChange}
                            />
                            <label htmlFor="singles" className="form-check-label person-number-label">
                                Singles
                            </label>
                        </div>
                        <div className="form-check me-3">
                            <input
                                type="radio"
                                id="doubles"
                                name="personsType"
                                className="form-check-input "
                                style={{ cursor: 'pointer' }}
                                value="Doubles"
                                checked={formData.personsType === "Doubles"}
                                onChange={handleRadioChange}
                            />
                            <label htmlFor="doubles" className="form-check-label person-number-label">
                                Doubles
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                type="radio"
                                id="more"
                                name="personsType"
                                style={{ cursor: 'pointer' }}
                                className="form-check-input"
                                value="MULTIPLAYER"
                                checked={formData.personsType === "MULTIPLAYER"}
                                onChange={handleRadioChange}
                            />
                            <label htmlFor="more" className="form-check-label person-number-label">
                                MULTIPLAYER
                            </label>
                        </div>
                    </div>
                </div>

                {formData.personsType === "MULTIPLAYER" &&
                    <div className="col-lg-3 ">
                        <label htmlFor="numberOfPersons" className="form-label">
                            Enter No. of Persons/Members <span className="text-danger">*</span>
                        </label>
                        <input
                            type="number"
                            id="numberOfPersons"
                            name="numberOfPersons"
                            max="100"
                            min="1"
                            className={`form-control form-control-border ${errors.numberOfPersons ? 'is-invalid' : ''}`}
                            value={formData.numberOfPersons}
                            onChange={handleInputChange}
                        />

                        {errors.numberOfPersons && <div className="invalid-feedback">{errors.numberOfPersons}</div>}
                    </div>
                }

                <div className="col-lg-5">
                    <div className="row create-game-date-picker">
                        <div className="col-lg-7">
                            <label htmlFor="Date-and-time" className="form-label">
                                Choose Date & Time <span className="text-danger">*</span>
                            </label>

                            <DatePicker
                                style={{ width: "100%", marginTop: "-22px" }}
                                selected={formData?.dateTime ? new Date(formData?.dateTime) : null}
                                onChange={(date) => {
                                    handleDateChange(date);
                                }}
                                minDate={new Date()}
                                maxDate={new Date(new Date().setMonth(new Date().getMonth() + 5))}
                                customInput={
                                    <CustomDatePicker
                                        label=""
                                        value={formatDate(formData?.dateTime)}
                                        name="dateTime"
                                        placeholder={'choose date and time'}
                                        customDateWrapper={`customDateWrapper ${errors.dateTime ? 'is-invalid' : ''}`}
                                    />
                                }
                                name="dateTime"
                                showTimeSelect
                                timeFormat="hh:mm aa"
                                timeIntervals={15}
                                dateFormat="MMM dd yyyy | hh:mm aa"
                                wrapperClassName="date-picker-wrapper"
                            />
                            {errors.dateTime && <div className="text-danger mt-1 small">{errors.dateTime}</div>}
                        </div>

                        <div className="col-lg-5">
                            <label htmlFor="duration" className="form-label">
                                Duration <span className="text-danger">*</span>
                            </label>
                            <div className="position-relative">
                                <select
                                    id="duration"
                                    name="duration"
                                    className={`form-control ${errors.duration ? 'is-invalid' : ''}`}
                                    style={{ fontSize: '15px', cursor: 'pointer' }}
                                    value={formData.duration}
                                    onChange={handleInputChange}
                                    disabled={!formData.dateTime}
                                >
                                    <option value="">Select</option>
                                    {durationOptions.map((val) => (
                                        <option key={val} value={val}>
                                            {val} Hrs
                                        </option>
                                    ))}
                                </select>
                                <FiChevronDown
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        pointerEvents: 'none',
                                        color: '#6c757d',
                                    }}
                                />
                            </div>
                            {errors.duration && <div className="invalid-feedback">{errors.duration}</div>}
                        </div>

                    </div>
                </div>


                {/* Checkboxes */}
                <div className="col-lg-3">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="exclusionList"
                            checked={checkboxValues.exclusionList}
                            onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label" htmlFor="exclusionList">
                            Not Visible for Exclusion List
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="autoAccept"
                            checked={checkboxValues.autoAccept}
                            onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label" htmlFor="autoAccept">
                            Auto Accept Requests
                        </label>
                    </div>
                </div>


                {/* Game Type */}
                <div className="col-lg-4 ">
                    <label className="form-label">Game Type</label>
                    <div className="d-flex align-items-center">
                        <div className="form-check me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="gameType"
                                value="open"
                                style={{ cursor: 'pointer' }}
                                checked={gameType === "open"}
                                onChange={() => {
                                    setGameType("open");
                                    setCheckboxValues((prev) => ({
                                        ...prev,
                                        autoAccept: false,
                                    }));
                                }}
                            />
                            <label className="form-check-label">Open Game</label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="gameType"
                                value="invitation"
                                style={{ cursor: 'pointer' }}
                                checked={gameType === "invitation"}
                                onChange={() => {
                                    setGameType("invitation");
                                    setCheckboxValues((prev) => ({
                                        ...prev,
                                        autoAccept: true,
                                    }));
                                }}

                            />
                            <label className="form-check-label">By Invitation Only</label>
                        </div>
                    </div>
                </div>

                {/* Price */}
                <div className="col-lg-4 ">
                    <label className="form-label">Court or Other Fees</label>
                    <div className="d-flex align-items-center">
                        <div className="form-check me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="priceType"
                                style={{ cursor: 'pointer' }}
                                value="noCharge"
                                checked={priceType === "noCharge"}
                                onChange={() => setPriceType("noCharge")}
                            />
                            <label className="form-check-label">No Fees</label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input "
                                type="radio"
                                style={{ cursor: 'pointer' }}
                                name="priceType"
                                value="paid"
                                checked={priceType === "paid"}
                                onChange={() => setPriceType("paid")}
                            />
                            <label className="form-check-label">Fee Amount Per Person</label>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    {priceType === "paid" && (
                        <div className="mt-0 mt-sm-2">
                            <label className="form-label">Per Person Fees</label>
                            <div className="position-relative">
                                <FaDollarSign className="dollar-icon" />
                                <input
                                    type="number"
                                    className="form-control form-control-border ps-4" // ps-4 = padding-start for space
                                    value={price}
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        // Allow empty input
                                        if (val === "") {
                                            setPrice("");
                                            return;
                                        }

                                        const number = parseFloat(val);

                                        if (!isNaN(number) && number <= 1000) {
                                            setPrice(val);
                                        }
                                    }}

                                    max={1000}
                                    min={0}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className="col-lg-4">
                    <label htmlFor="description" className="form-label">
                        Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                        style={{ height: '80px' }}
                        className={`form-control form-control-border create-game-text-area ${errors.description ? 'is-invalid' : ''}`}
                        id="description"
                        name="description"
                        placeholder="Write a description about the game"
                        value={formData.description}
                        onChange={handleInputChange}
                    />
                    {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                </div>
            </div>

            <div className="text-center mt-4 mt-sm-5">
                <CustomButton
                    buttonText="Save"
                    type="submit"
                    className="btn btn-blue text-white create-submit-btn"
                    onClick={(e) => handleSubmit(e)}
                />
            </div>

            {showMap ? (
                courtData?.length > 0 ? (
                    <div className="modal-overlay open">
                        <div className="modal-content map-modal-wrapper">
                            <button onClick={() => setShowMap(false)} className="close-button">
                                <RxCross2 className="fs-4" />
                            </button>
                            <h4 className="mb-3">Map View</h4>
                            <GoogleMapComponent
                                courtData={courtData}
                                onCourtSelect={handleCourtSelectFromMap}
                                onShowMapModal={() => setShowMap(true)}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="d-flex align-items-center justify-content-center" style={{ height: '59vh' }} >
                        <h2 className="text-center mt-3 fs-2" style={{ fontWeight: '600', color: 'rgba(33, 37, 41, 0.75)' }}>No Games Found In Your Location</h2>
                    </div>
                )
            ) : null}
        </>
    )
}
export default CreateFormField;